import { CheckoutFeature as GQLItem } from '../generated/checkout.graphql';

export type FeatureKey =
  'order_company_info'
  | 'joinit';

export type CheckoutFeatures = {
  readonly [key in FeatureKey]?: boolean;
};

export const fromGqlCollection = (gqlCollection: GQLItem[]): CheckoutFeatures =>
  gqlCollection.reduce(
    (acc, item) => ({
      ...acc,
      [item.feature]: item.enabled,
    }),
    {} as CheckoutFeatures,
  );
